var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-main',{style:({ 'min-height': (_vm.elementHeight + "px") })}),_vm._v(" "),_c('publicFooter'),_vm._v(" "),_c('publicMask',{attrs:{"fullscreenLoading":_vm.fullscreenLoading}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71bbb2fe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/oneTouch.vue
// module id = null
// module chunks = 